import WRAP from 'WRAP-JS'
import { COMMUNICATE_ERROR_MESSAGE_ELEVATION, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD } from "../../../constants/ErrorMessage";
import { MAP_ID_ELEVATION } from "../../../store/MapContentsState";
import { m2ft } from "../../../utils/FPEUtils";
// import LegendElevation from "../legend/LegendElevation";
import { configElevationDh, configTerrainElevationsDh } from "./config/ConfigElevation";

class Elevation {
  static NAME = MAP_ID_ELEVATION;
  static ELEVATION_ELEVATION = 'Elevation';
  static ELEVATION_TERRAIN_ELEVATION = 'TerrainElevation';
  static CONTENTS_VISIBLE_STATE_DEFAULT = {
    [Elevation.ELEVATION_ELEVATION]: true,
    [Elevation.ELEVATION_TERRAIN_ELEVATION]: true,
  };

  contentsVisibleState = {...Elevation.CONTENTS_VISIBLE_STATE_DEFAULT};

  elevationDh;
  terrainElevationsDh;
  ready = false;
  maximumTerrainElevationsData;
  contentsDispatcher;
  errorMessageInfo = {};
  elevationBox;

  constructor() {
    this.initData();
    this.initLayer();
  }

  initData() {
    this.elevationDh = new WRAP.Data(configElevationDh);
    this.terrainElevationsDh = new WRAP.Data(configTerrainElevationsDh);
  }

  initInteraction() {
    const mapDiv = document.getElementById('map-container');
    this.elevationBox = document.getElementById('elevation');
    const elevationValue = this.elevationBox.querySelector('.value');

    const featureGrid = new WRAP.Geo.Feature.GeoLine({
      path: [],
      fillStyle: 'rgba(255, 0, 0, 0)',
      strokeStyle: '#85200c',
      lineWidth: 4,
      method:'EC'
    });
    const featureHightDigits = new WRAP.Geo.Feature.Text({
      point: [],
      text: "",
      fontSize: 40,
      offsetY: 20,
      strokeStyle: '#555',
      align: 'right'
    });
    const featureLowDigits = new WRAP.Geo.Feature.Text({
      point: [],
      text: "",
      fontSize: 34,
      offsetY: 16,
      strokeStyle: '#555',
      align: 'left'
    });
    this.layer.addFeature(featureGrid);
    this.layer.addFeature(featureHightDigits);
    this.layer.addFeature(featureLowDigits);
    mapDiv.addEventListener('mousemove', event => {

      if (this.visible) {
        const rect = event.currentTarget.getBoundingClientRect();
        let x = event.clientX - rect.left;
        let y = event.clientY - rect.top;
        const sp = {x, y};
        const p = WRAP.Geo.getPoint(sp);
        const lon = p.lonDegree();
        const lat = p.latDegree();

        //Elevation
        if(this.contentsVisibleState[Elevation.ELEVATION_ELEVATION]) {
          this.elevationDh.getPointValue('data', [lon, lat], null, null,
            (value) => {
              elevationValue.innerText = `${Math.round(m2ft(value)).toLocaleString()}`;
            },
            () => {
              elevationValue.innerText = `---`;
            }
          );
        }

        //Terrain Elevation
        let hide = false;
        if(this.ready && this.contentsVisibleState[Elevation.ELEVATION_TERRAIN_ELEVATION]) {
          const grid = this.maximumTerrainElevationsData.region.Grid;
          if(grid.LonBase <= lon && grid.LonBase + grid.Width * grid.LonInterval > lon
            && grid.LatBase >= lat && grid.LatBase - grid.Height * grid.LatInterval < lat) {

            const x = Math.floor((lon - grid.LonBase) / grid.LonInterval);
            const y = Math.floor((grid.LatBase - lat) / grid.LatInterval);
            const elevation = this.maximumTerrainElevationsData.elevation[y][x];
            if(elevation !== null) {
              const glon = grid.LonBase + grid.LonInterval * x;
              const glat = grid.LatBase - grid.LatInterval * y;

              const style = featureGrid.style();
              style.path = [
                [glon, glat],
                [glon + grid.LonInterval, glat],
                [glon + grid.LonInterval, glat - grid.LatInterval],
                [glon, glat - grid.LatInterval],
                [glon, glat],
              ];

              const textHigh = ("" + elevation).slice(0, -1).padStart(1, "0");
              const textLow = ("" + elevation).slice(-1);
              featureHightDigits.style().point = featureLowDigits.style().point = [glon + grid.LonInterval / 2, glat - grid.LatInterval / 2];
              featureHightDigits.style().text = textHigh;
              featureLowDigits.style().text = textLow;
            } else {
              hide = true;
            }
          } else {
            hide = true;
          }
        } else {
          hide = true;
        }
        if(hide) {
          featureGrid.style().path = [];
          featureHightDigits.style().point = [];
          featureLowDigits.style().point = [];
        }
        // WebGLの再描画条件
        this.layer._immediate = true;
        this.layer._modified = true;
        WRAP.Geo.invalidate();
      }
    }, false);
  }

  initLayer() {
    this.layer = new WRAP.Geo.Layer("Elevation");
    this.layer.disableInteraction(true);
    this.layer.setVisible(false);
  }

  getLayer() {
    return [this.layer];
  }

  async drawLayer(visible) {
    this.visible = visible;
    Object.entries(this.contentsVisibleState).forEach(([name, visible]) => {
      this._setContentsVisible(name, visible);
    });
    if(!this.ready) {
      await this.initTerrainElevationsData();
      this.ready = true;
      // this._makeElevationGrid();
    }
  }

  // getLegend() {
  //   return {
  //     id: Elevation.NAME,
  //     label: 'Elevation',
  //     component: LegendElevation,
  //     contents: this
  //   }
  // }

  getContentsVisibleState() {
    return this.contentsVisibleState;
  }

  resetContentsVisibleState() {
    this.contentsVisibleState = {...Elevation.CONTENTS_VISIBLE_STATE_DEFAULT};
    this.elevationDispatcher({ type: 'RESET_CONTENTS_VISIBLE', payload: {...this.getContentsVisibleState()}});
  }

  setContentsVisible(name, visible) {
    this.contentsVisibleState[name] = visible;
    this._setContentsVisible(name, visible);
    this.elevationDispatcher({ type: 'SET_CONTENTS_VISIBLE', payload: { name, visible } });
  }

  async initTerrainElevationsData() {
    const [region, data] = await Promise.all(['region', 'data'].map(id => {
      return new Promise(resolve => {
        this.terrainElevationsDh.load(id, null, false, data => {
          if (this.errorMessageInfo[id]) {
            this.contentsDispatcher({type: 'CLEAR_ERROR', payload: this.errorMessageInfo[id]});
            this.errorMessageInfo[id] = null;
          }
          resolve(data);
        }, data => {
          this.errorMessageInfo[id] = this.contentsDispatcher({
            type: 'SHOW_ERROR',
            payload: {
              message: COMMUNICATE_ERROR_MESSAGE_ELEVATION,
              replacement: {data: `${id === 'region' ? 'region_terrain_elevations' : 'maximum_terrain_elevations'}`},
              additionalMessage: id === 'region' ? COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER : COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD
            }
          });
        });
      });
    }));
    this.maximumTerrainElevationsData = Object.assign({}, {
      region,
      "elevation": data.split(/\r?\n/).filter(line => line !== '').map(line => {
        return line.split(/,/).map(d => {
          if(d !== '') return parseInt(d);
          return null;
        });
      })
    });
  }

  _setContentsVisible(name, visible) {
    switch(name) {
      case Elevation.ELEVATION_ELEVATION:
        if(this.visible && visible) {
          this.elevationBox.style.display = 'block';
        } else {
          this.elevationBox.style.display = 'none';
        }
        break;
      case Elevation.ELEVATION_TERRAIN_ELEVATION:
        if(this.visible && visible) {
          this.layer.show();
        } else {
          this.layer.hide();
        }
        break;
      default:
        break;
    }
  }

  _makeElevationGrid() {
    const grid = this.maximumTerrainElevationsData.region.Grid;
    for(let y = 0; y < grid.Height; y++) {
      for(let x = 0; x < grid.Width; x++) {
        const elevation = this.maximumTerrainElevationsData.elevation[y][x];
        if(elevation !== null) {
          const lon = grid.LonBase + grid.LonInterval * x;
          const lat = grid.LatBase - grid.LatInterval * y;
          const path = [
            [lon, lat],
            [lon + grid.LonInterval, lat],
            [lon + grid.LonInterval, lat - grid.LatInterval],
            [lon, lat - grid.LatInterval],
            [lon, lat],
          ];
          this.layer.addFeature(new WRAP.Geo.Feature.GeoLine({
            path: path,
            fillStyle: 'rgba(255, 0, 0, 0)',
            strokeStyle: '#888',
            lineWidth: 1,
            method: 'EC'
          }));
          const textHigh = ("" + elevation).slice(0, -1).padStart(1, "0");
          const textLow = ("" + elevation).slice(-1);
          const point = [lon + grid.LonInterval / 2, lat - grid.LatInterval / 2];
          this.layer.addFeature(new WRAP.Geo.Feature.Text({
            point: point,
            text: textHigh,
            fontSize: 40,
            offsetY: 20,
            strokeStyle: '#555',
            fillStyle: 'none',
            align: 'right'
          }));
          this.layer.addFeature(new WRAP.Geo.Feature.Text({
            point: point,
            text: textLow,
            fontSize: 34,
            offsetY: 16,
            strokeStyle: '#555',
            fillStyle: 'none',
            align: 'left'
          }));
        }
      }
    }
    // WebGLの再描画条件
    this.layer._immediate = true;
    WRAP.Geo.invalidate();
  }

  setContentsDispatcher(dispatcher) {
    this.contentsDispatcher = dispatcher;
  }

  setElevationDispatcher(dispatcher) {
    this.elevationDispatcher = dispatcher;
  }
}

export default Elevation;
